import {InvitedUser, User} from "../types/domain.ts";
import {ROLE_MAP} from "../constants/constants.ts";
import {isRegionManager, isStaff} from "./userTypeGuards.ts";

export const getUserOrigin = (user: User | InvitedUser, role?: boolean) => {
    const r = role ? `${ROLE_MAP[user.role]} ` : '';
    if(isStaff(user)) return 'Стафф';
    if(isRegionManager(user)) return `${r}${user.region!.name}`;
    return `${r}${user.firs.map(({ name }) => name).join(', ')}`;
}